<div class="detail">
    <div class="header">
        <span class="title">Selected Property Details:</span>
        <span><i class="fas fa-map-marker"></i></span>
        <span class="street">{{address}}</span>
    </div>
    <div class="info">
        <div class="name">
            Address
        </div>
        <div class="value">
            {{address}}
        </div>
        <div class="name">
            Unit #
        </div>
        <div class="value">
            {{publicRecord.propertyRecord.unitNumber}}
        </div>
        <div class="name">
            State
        </div>
        <div class="value">
            {{publicRecord.propertyRecord.state}}
        </div>
        <div class="name">
            City
        </div>
        <div class="value">
            {{publicRecord.propertyRecord.city}}
        </div>
        <div class="name">
            ZIP
        </div>
        <div class="value">
            {{publicRecord.propertyRecord.postalCode}}
        </div>
        <div class="name">
            Owner Name
        </div>
        <div class="value">
            Richard Ashcroft
        </div>
        <div class="name">
            APN /TAX ID
        </div>

        <div class="value">
            {{publicRecord.propertyRecord.parcelNumber}}
        </div>
    </div>
    <!-- <div class="info">
		<p class="small">
			<strong>Lot size:</strong> {{publicRecord.propertyRecord.lotSize}}
		</p>
		<p class="small">
			<strong>Year Built:</strong> {{publicRecord.propertyRecord.yearBuilt}}
		</p>
	</div> -->
    <div class="footer">

        <!-- <div class="source">Source: Black Knight Public Records</div> -->
    </div>
    <span class="submit-subject"
          (click)="usAsSubject()">USE AS SUBJECT</span>
</div>
